module.exports = __webpack_public_path__ + "img/icon-score4.2c364dfb.svg";